import { Box } from "arkh";
import { TabButton } from "./TabBar/TabButton";

export function TabBar<T extends string>(props: {
  tabs: {
    title: string | React.ReactNode;
    key: T;
    badge: React.ReactElement | null;
  }[];
  state: T;
  setState: (state: T) => void;
}) {
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
      }}
      spaceBottom="medium"
      spaceHorizontal="xsmall"
      color="surface-primary"
    >
      {props.tabs.map((tab) => (
        <TabButton
          key={tab.key}
          title={tab.title}
          badge={tab.badge}
          isActive={props.state === tab.key}
          onPress={() => props.setState(tab.key)}
        />
      ))}
    </Box>
  );
}
